import VerticalStaticNumberedSteps from "./VerticalStaticNumberedSteps";

export default VerticalStaticNumberedSteps;
